/**
 * parallaxBkImg
 */
const parallaxBkImg = (function () {
    $(window).on('load resize', function () {
        $(window).on('load scroll', function () {
            let $winTop = $(window).scrollTop();
            let $target = $('.cd-fixed-bg');
            let $winWidth = $(window).width();
            if ($winWidth < 736) {
                $target.each(function (index) {
                    let $position = $winTop - $target.eq(index).offset().top;
                    if ($winTop > $target.eq(index).offset().top - 800) {
                        $target.eq(index).css({
                            'background-position-y': $position * 0.4
                        });
                    }
                });
            }
        });
    });
})();

/**
 * Page Scroll
 *
 */
const Ease = {
    easeInOut: (t) =>
        t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
};
const duration = 500;
const pos = 0;
window.addEventListener('DOMContentLoaded', () => {
    let smoothScrollTriggers = document.querySelectorAll('a[href^="#"]');
    smoothScrollTriggers.forEach(function (smoothScrollTrigger) {
        smoothScrollTrigger.addEventListener('click', function (e) {
            let href = smoothScrollTrigger.getAttribute('href');
            let currentPostion =
                document.documentElement.scrollTop || document.body.scrollTop;
            let targetElement = document.getElementById(href.replace('#', ''));
            if (targetElement) {
                e.preventDefault();
                e.stopPropagation();
                let targetPosition =
                    window.pageYOffset +
                    targetElement.getBoundingClientRect().top -
                    pos;
                let startTime = performance.now();
                let loop = function (nowTime) {
                    let time = nowTime - startTime;
                    let normalizedTime = time / duration;
                    if (normalizedTime < 1) {
                        window.scrollTo(
                            0,
                            currentPostion +
                                (targetPosition - currentPostion) *
                                    Ease.easeInOut(normalizedTime)
                        );
                        requestAnimationFrame(loop);
                    } else {
                        window.scrollTo(0, targetPosition);
                    }
                };
                requestAnimationFrame(loop);
            }
        });
    });
});

/**
 * GSAP: ScrollTrigger
 *
 */
gsap.to('.main-title', {
    scrollTrigger: {
        trigger: '.main-title',
        start: 'top top',
        toggleActions: 'play pause resume reset'
        //markers: true
    },
    opacity: 0
    //rotation: 360,
    //duration: 3
});

/**
 *
 */
// Scroll Position
$(window).scroll(function () {
    const topY = 70;
    let posY = $(this).scrollTop();
    //console.log(posY);

    if (posY >= topY) {
        ////$(".header-white, .header-black").css(
        ////  "box-shadow",
        ////  "0 1px 1px rgba(0, 0, 0, 0.2)"
        ////);
    } else if (posY < topY) {
        //$('.header-white, .header-black').css('box-shadow', 'none');
    }
});

/**
 * ScrollReveal
 */
const SRparams = {
    // Exspand
    //duration: 500,
    //scale: 3,
    //reset: true,

    // TOP
    duration: 600,
    origin: 'bottom',
    distance: '60px',
    reset: true

    //
    //duration: 800, // アニメーションの完了にかかる時間
    //viewFactor: 0.2, // 0~1,どれくらい見えたら実行するか
    //reset: true, // 何回もアニメーション表示するか
};
ScrollReveal().reveal('.sr-box', SRparams);

/**
 * Respmenus
 */
const Respmenus = {
    respmenu: false,

    view: function () {
        if (!Respmenus.respmenu) {
            $('.resp__contents__inner').css('opacity', '0.99');
            $('.resp__contents__inner').css('right', '0');
            $('.resp__contents__inner').on(
                'transitionend webkitTransitionEnd',
                function () {
                    Respmenus.respmenu = true;
                }
            );
        } else {
            $('.resp__contents__inner').css('opacity', '0');
            $('.resp__contents__inner').css('right', '-100%');
            $('.resp__contents__inner').on(
                'transitionend webkitTransitionEnd',
                function () {
                    Respmenus.respmenu = false;
                }
            );
        }
    }
};

/**
 * SeasonResult
 */
const SeasonResult = {
    active: false,
    view: function (obj) {
        let raceId = $(obj).data('race_id');

        if (!SeasonResult.active) {
            $('#' + raceId).show();
            SeasonResult.active = true;
            $('#' + raceId).addClass('sr-box');
            ScrollReveal().reveal('.sr-box', SRparams);
        } else {
            $('#' + raceId).hide();
            SeasonResult.active = false;
            $('#' + raceId).removeClass('sr-box');
        }
    }
};

/**
 * Events
 */
$(window).on('load', function () {
    $(
        '.resp__contents__button, .resp__contents__inner--nav a, .resp__contents__inner--subnav a'
    ).on('click', function () {
        Respmenus.view();
    });

    // TODO
    $('.block-race').on('mouseenter', function () {
        let raceId = $(this).data('race_id');
        if (!raceId) return;

        //$(this).addClass('hoge');
    });
    $('.block-race').on('click', function () {
        SeasonResult.view(this);
    });
});

/**
 * Modal Image
 *
 */
const modalWrapper = document.querySelector('.modal-wrapper');
const images = document.querySelectorAll('.m-image');
const modalImage = document.querySelector('.modal-image');

images.forEach(function (image) {
    image.addEventListener('click', function () {
        modalWrapper.classList.add('show');
        modalImage.classList.add('show');

        var imageSrc = image.getAttribute('data-src');
        modalImage.src = imageSrc;
    });
});
modalWrapper.addEventListener('click', function () {
    if (this.classList.contains('show')) {
        this.classList.remove('show');
        modalImage.classList.remove('show');
    }
});
